import {GotoPageHandlerInterface} from 'src/providers/pushnotification-service/pushnotification-handler';
import {NavController} from '@ionic/angular';
import {AbstractNotificationHandlerPage} from 'src/providers/pushnotification-service/notification-handler-constructs';
import * as global from 'src/globals';
//import {FriendListPage} from './friend-list/friend-list';
import { CompetitionDetailsPage } from './competition/competition-details/competition-details.page';
import { CompetitionFlightsPage } from './competition/competition-flights/competition-flights.page';


/**
 * Created by ashok on 20/03/17.
 */

export class MygolfGotoPageHandler implements GotoPageHandlerInterface {
    gotoPage(nav: NavController, type: string, data: any, needRefresh: boolean) {
        if(type === AbstractNotificationHandlerPage.TYPE_COMP_ROUND_STARTED){
            global.SharedObject.homeInfo.needRefresh = true;
            // this.nav.popToRoot();
           // nav.popToRoot();
        }
        else if(type === AbstractNotificationHandlerPage.TYPE_COMP_INFO_CHANGED){
            let compId = data.competitionDetailChanged;
            // nav.push(CompetitionDetailsPage,{
            //     competitionId: compId
            // });
        }
        else if(type === AbstractNotificationHandlerPage.TYPE_FLIGHTS_GENERATED){
            let compId = data.competitionId;
            let roundNo = data.roundNo;
            // nav.push(CompetitionFlightsPage,{
            //     competitionId: compId,
            //     roundNo: roundNo
            // });
        }
        else if(type === AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST){
            // alert("Pushing friend list page");
            // nav.push(FriendListPage,{
            //     homeInfo: global.SharedObject.homeInfo
            // });
        }
        else if(type === AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST_ACCEPTED){
            // alert("Pushing friend list page");
            // nav.push(FriendListPage,{
            //     homeInfo: global.SharedObject.homeInfo
            // });
        }
    }

}